<div class="auth-container new-password">
	<sf-auth-top-bar></sf-auth-top-bar>
	<div class="card auth-content">
		<div
			*ngIf="!(isConfirmationVisible | async); else confirmation"
			class="new-password-form"
			[formGroup]="newPasswordForm"
		>
			<h3 class="sf title">{{ 'sf.module.auth.new_password.title' | translate }}</h3>
			<span class="caption">{{ 'sf.module.auth.new_password.caption' | translate }}</span>
			<div class="fields">
				<div class="field-wrapper password">
					<sf-input-password
						class="top"
						formControlName="password"
						[showPasswordHint]="true"
						[placeholder]="'sf.module.auth.common.password' | translate"
					>
					</sf-input-password>
				</div>

				<div class="field-wrapper repeat-password">
					<sf-input-password
						class="top"
						formControlName="passwordRepeat"
						[placeholder]="'sf.module.auth.common.repeat_password' | translate"
					>
						<span *ngIf="newPasswordForm.controls['passwordRepeat'].hasError('confirmedValidator')"
							>{{ 'sf.common.validation.errors.field_password_match' | translate }}
						</span>
					</sf-input-password>
				</div>
			</div>
			<div class="checkbox-group">
				<div *ngIf="policyAndTermsControl" class="field-wrapper">
					<mat-checkbox formControlName="policyAndTerms">
						<span
							[innerHTML]="
								'sf.module.auth.sign_up.agreement_info' | translate: { policy: '/assets/documents/privacy_policy.pdf' }
							"
						></span>
						<mat-error
							*ngIf="policyAndTermsControl.hasError('required') && policyAndTermsControl.dirty"
							class="checkbox-error"
							>{{ 'sf.common.validation.errors.field_required' | translate }}</mat-error
						>
					</mat-checkbox>
				</div>
				<div *ngIf="generalTermsControl" class="field-wrapper">
					<mat-checkbox formControlName="generalTerms">
						<span
							[innerHTML]="
								'sf.module.license.invoice_details.customer_details.general_terms'
									| translate: { terms: '/assets/documents/terms_of_use.pdf' }
							"
						></span>
						<mat-error
							*ngIf="generalTermsControl.hasError('required') && generalTermsControl.dirty"
							class="checkbox-error"
							>{{ 'sf.common.validation.errors.field_required' | translate }}</mat-error
						>
					</mat-checkbox>
				</div>
				<div *ngIf="newsletterControl" class="field-wrapper">
					<mat-checkbox formControlName="newsletter" id="newsletter">
						<span
							>{{ 'sf.module.auth.sign_up.newsletter_info' | translate }}
							<span *ngIf="showNewsletterInfo | async">{{
								'sf.module.auth.sign_up.newsletter_full_info' | translate
							}}</span>
							<a class="show-more" (click)="showMore($event)">{{
								((showNewsletterInfo | async) ? 'sf.module.auth.sign_up.show_less' : 'sf.module.auth.sign_up.show_more')
									| translate
							}}</a>
						</span>
					</mat-checkbox>
				</div>
			</div>

			<button class="save" mat-flat-button color="accent" (click)="onSave()" [disabled]="newPasswordForm.invalid">
				{{ 'sf.common.save' | translate | uppercase }}
			</button>
		</div>
		<div class="separator"></div>
		<div class="back-to-login-wrapper">
			<a class="link" routerLink="/">
				{{ 'sf.module.auth.common.back_to_login' | translate }}
			</a>
		</div>
		<ng-template #confirmation>
			<h3 class="sf title">{{ 'sf.module.auth.new_password.confirmation_title' | translate }}</h3>
			<span class="caption">{{ 'sf.module.auth.new_password.confirmation' | translate }}</span>
		</ng-template>
	</div>
	<sf-contact-footer></sf-contact-footer>
</div>
